/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Loader from '../../assets/svgs/Loader';

const SettingsBy = ({ className, onModalChange }) => {
    return (
        <div className={className}>
            <h3>
                <Loader />
                انتخاب سوال‌ها بر اساس
            </h3>

            <ul>
                <li onClick={() => onModalChange('ByUser')}>
                    پرسش های بدون پاسخ
                </li>
                <li onClick={() => onModalChange('ByAdmin')}>
                    پرسش های پاسخ داده شده
                </li>
                <li onClick={() => onModalChange('Lock')}>پرسش های بسته شده</li>
                <li onClick={() => onModalChange('All')}>همه پرسش ها</li>
                <li onClick={() => onModalChange('close')}>بستن</li>
            </ul>
        </div>
    );
};

SettingsBy.propTypes = {
    className: PropTypes.string.isRequired,
    onModalChange: PropTypes.func.isRequired
};

export default styled(SettingsBy)`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    display: flex;
    flex-flow: column wrap;
    align-items: center;
    justify-content: center;
    padding: 32px;
    border-top-left-radius: 32px;
    border-top-right-radius: 32px;

    > * {
        display: flex;
        align-items: center;
        width: 100%;
    }

    > h3 {
        margin-bottom: 30px;
        font-size: 16px;
        font-weight: bold;
        color: #0d1fa1;
        line-height: 28px;

        > svg {
            margin-left: 10px;
        }
    }

    > ul {
        flex-direction: column;

        li {
            width: 100%;
            padding: 12px 0px;
            font-size: 14px;
            font-weight: 400;
            color: #000946;
            line-height: 25px;
            cursor: pointer;

            &:last-child {
                padding-bottom: 0;
            }

            &:first-child {
                padding-top: 0;
            }
        }
    }
`;
